/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

interface ISocialLinkProps {
  name: string;
  link: string;
}

interface INodeProps {
  uuid: string;
  name: string;
  display: "app-card" | "product-card";
  socialLinks?: ISocialLinkProps[];
  description?: string;
  logo?: string;
  bannerImage?: string;
  metaData?: any;
}

interface ICollection {
  id: string;
  title?: string;
  description?: string;
  image?: string;
  catalogueType?: "leaf" | "catalogue";
  [key: string]: any;
}

export class CollectionListMessage {
  criteria?: any;
  offset?: number;
  size?: number;
  collectionId?: string;

  node?: INodeProps;
  ancestors?: INodeProps[];
  children?: {
    data: INodeProps[];
    currentPage: number;
    totalPages: number;
    totalCount: number;
  };
  isLeafNode?: boolean;

  leafNodes?: {
    data: any[];
    currentPage: number;
    totalPages: number;
    totalCount: number;
  };

  collection?: {
    collectionList?: ICollection[];
    currentPage: number;
    totalPages: number;
    totalCount: number;
  };

  constructor({ offset = 0, size = 12 }: { offset: number; size: number }) {
    this.offset = offset;
    this.size = size;
    const [host, collection, uuid] = window.location.pathname.split("/");
    this.collectionId = uuid;
    this.isLeafNode = false;
    this.collection = {
      collectionList: [],
      currentPage: 0,
      totalPages: 0,
      totalCount: 0,
    };
    this.leafNodes = {
      data: [],
      currentPage: 0,
      totalPages: 0,
      totalCount: 0,
    };
  }
}
